'use strict';

goog.provide("Ntry.Playground");

Ntry.Playground = function() {
    var that = this;
    this._workspaceScript = {};
    this._view = Ntry.interfaceManager.getDom('ntryPlayground');
    this.createDom();
    this.injectBlockly();
    this.bindMouseEventToBlockMenu();
    this.setBlockMenu();
    this.isResizing = false;
    this._currentCnt = -1;
    Ntry.addEventListener("workspaceRestore", this, this.syncScript);

    var blocklyCanvas = Blockly.mainWorkspace.svgBlockCanvas_;
    blocklyCanvas.addEventListener('blocklyWorkspaceChange', function(){
        that.updateCurrentBlockNumber(Ntry.countUsedBlocks());
    });

    //Entry.addEventListener('entryBlocklyMouseUp', this.mouseupBlock);
};

(function(p){

    p.createDom = function () {
        var parent = this._view;
        var colTop = Ntry.createElement('div', parent, null, 'ntryRightColTop');
        this._currentBlockNumber = Ntry.createElement('div', colTop, null, 'currentBlockNumber');
        this._goalBlockNumber = Ntry.createElement('div', colTop, null, 'goalBlockNumber');

        this.topbackground = Ntry.createElement('div', colTop, null, 'topbackground');

        var info = Ntry.createElement('div', parent, null, 'ntryRightColInfo');
        Ntry.createElement('div', info, null, 'ntryRightColInfoLeft').
            innerHTML = Lang.Menus.block_box;
        Ntry.createElement('div', info, null, 'ntryRightColInfoRight').
            innerHTML = Lang.Menus.block_assembly;

        var playground = Ntry.createElement('div', parent, null, 'ntryPlayground');
        this._blockMenu = Ntry.createElement('div', playground, null,
                             'ntryPlaygroundBlockMenu', 'blockMenuWorkspace', 'selectDisable');
        this._workspace = Ntry.createElement('div', playground, null, 'ntryPlaygroundWorkspace');

        this.blockBg = Ntry.createElement('div', this._blockMenu, null, 'blockBackground');
    };

    p.syncScript = function() {
        var entityManager = Ntry.entityManager;
        var script = Blockly.Xml.workspaceToDom(Blockly.mainWorkspace);
        script = Blockly.Xml.domToText(script);
        script = script.replace(/\sxmlns=\"(.*?)\"/,"");
        script = script.replace(/\sclass=\"(.*?)\"/g,'');
        script = script.replace(/\sid=\"(.*?)\"/g,"");
        script = script.replace(/\sinline=\"(.*?)\"/g,"");

        var entities = entityManager.getEntitiesByComponent(Ntry.STATIC.SCRIPT_CONTAINER);
        if (_.isEmpty(entities)) return;
        else {
            var key = _.first(_.keys(entities));
            entityManager.addComponent(key, {
                "script": script,
                "timeStamp": new Date().getTime(),
                "type": Ntry.STATIC.SCRIPT_CONTAINER
            });
        }
    };

    p.update = function() {
        var entityManager = Ntry.entityManager;
        var entities = entityManager.getEntitiesByComponent(Ntry.STATIC.SCRIPT_CONTAINER);
        var componentTimeStamp;
        if (_.isEmpty(entities)) return;
        else {
            var key = _.first(_.keys(entities));
            var component = entityManager.getComponent(key,
                            Ntry.STATIC.SCRIPT_CONTAINER);
            this._workspaceScript.script = component.script;
            componentTimeStamp = component.timeStamp;
            var workspaceScript = this._workspaceScript;
            if (!workspaceScript.timeStamp ||
                    workspaceScript.timeStamp< componentTimeStamp) {
                workspaceScript.timeStamp = componentTimeStamp;
                this.setWorkspace(this._workspaceScript.script);
            }
        }

    };

    p.loadConfig = function () {

        this.updateGoalBlockNumber(Ntry.configManager.getConfig("limitBlockCnt"));

        this.setBlockMenu(Ntry.configManager.getConfig("availableBlocks"));
    };

    p.setBlockMenu = function (allBlocks) {
        var xmlList = [];
        _.each(allBlocks, function(b) {
            var block = Ntry.STATIC.blockInfo[b];
            if (block.xmls) {
                _.each(block.xmls, function(xml){
                    xmlList.push(jQuery.parseXML(xml).childNodes[0]);
                });
            } else
                xmlList.push(jQuery.parseXML(block.xml).childNodes[0]);
        });
        Blockly.mainWorkspace.blockMenu.show(xmlList);
    };

    p.setWorkspace = function (xml) {
        Blockly.mainWorkspace.clear();
        Blockly.Xml.domToWorkspace(Blockly.mainWorkspace,
                               $.parseXML(xml).childNodes[0]);
    };

    p.setIsResizing = function (bool) {
        Ntry.playground.isResizing = bool;
    };

    p.injectBlockly = function () {
        Blockly.inject(
            this._workspace,
            {
                path: '.././',
                toolbox: Ntry.parseTexttoXML('<xml></xml>'),
                trashcan: true,
                blockmenu: this._blockMenu,
                mediaFilePath: '/lib/entryjs/images/'
            });
        Blockly.mainWorkspace.flyout_.hide();

    };

    p.updateCurrentBlockNumber = function (num) {
        if (this._currentCnt == num)
            return;
        else {
            this._currentCnt = num;
            this._currentBlockNumber.innerHTML = Lang.Menus.used_blocks + ': ' + num;
        }
    };

    p.updateGoalBlockNumber = function (num) {
        this._goalBlockNumber.innerHTML = Lang.Menus.maximum + ': ' + num;
    };

    p.bindMouseEventToBlockMenu = function () {
        var blockMenu = this._blockMenu;

        $(blockMenu).mouseenter(function(e) {
            if (this.isResizing)
                return;
            var width = Blockly.mainWorkspace.blockMenu.blockMenuWidth + 84;
            if (Blockly.mainWorkspace.blockMenu.blockMenuWidth > 200) {
                this.widthBackup = 200;
                $('.ntryPlaygroundBlockMenu>svg').stop().animate({
                    width: width - 64
                }, 200);
            }
        });

        $(blockMenu).mouseleave(function(e) {
            if (this.isResizing)
                return;
            if (blockMenu.widthBackup &&
                !Blockly.mainWorkspace.blockMenu.hasStalkerBlock)
                $('.ntryPlaygroundBlockMenu>svg').stop().animate({
                    width: this.widthBackup
                }, 200);
            delete this.widthBackup;
        });
    };

    p.mouseupBlock = function() {
        if (Entry.activityReporter) {
            var script = Blockly.Xml.workspaceToDom(Blockly.mainWorkspace);
            script = Blockly.Xml.domToText(script);
            script = script.replace(/\sxmlns=\"(.*?)\"/,"");
            script = script.replace(/\sclass=\"(.*?)\"/g,'');
            script = script.replace(/\sid=\"(.*?)\"/g,"");
            script = script.replace(/\sinline=\"(.*?)\"/g,"");
            var data = [
                ['script', script]
            ];
            Entry.activityReporter.add(new Entry.Activity('editBlock', data))
        }
    }
})(Ntry.Playground.prototype);


